export default [
    {
        image: '/static/images/cat-shoes.jpg',
        name: 'Comprobantes ilimitados',
        category: 'Emite comprobantes sin límite.',
    },
    {
        image: '/static/images/women/9-item-a.jpg',
        name: 'Interfaz intuitiva',
        category: 'Vende con un sistema amigable.',
    },
    {
        image: '/static/images/gadgets/g-5-a.jpg',
        name: 'Actualizaciones continuas',
        category: 'Ofrecemos mejoras continuas',
    },
    {
        image: '/static/images/gadgets/g-5-b.jpg',
        name: 'Integración inmediata',
        category: 'Vende en menos de 2 horas',
    },
];
